import React, { Fragment, useRef } from "react"
import { CtaBar, IconButton, CaptureButton } from "./styled"
import HiddenImageInput from "components/inputs/ImageUploader/HiddenImageInput"
import GalleryIcon from "components/Icons/GalleryIcon"

interface CaptureControlsProps {
  onCapture: () => void
  isDisabledCapture: boolean
  isDisabledFileInput: boolean
  onImageChange: (file?: File | undefined) => void
}

const CaptureControls: React.FC<CaptureControlsProps> = ({
  onCapture,
  isDisabledCapture,
  isDisabledFileInput,
  onImageChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleGalleryClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <Fragment>
      <CtaBar>
        <IconButton
          disabled={isDisabledFileInput}
          onClick={handleGalleryClick}
          aria-label="Select from gallery"
        >
          <GalleryIcon />
        </IconButton>

        <CaptureButton
          onClick={onCapture}
          disabled={isDisabledCapture}
          aria-label="Capture photo"
        />

        <div style={{ width: 48, height: 48, flexShrink: 0 }}></div>
      </CtaBar>
      <HiddenImageInput
        ref={fileInputRef}
        onChange={(image?: File) => {
          onImageChange(image)
        }}
      />
    </Fragment>
  )
}

export default CaptureControls
